"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_visibility_sensor_1 = __importDefault(require("react-visibility-sensor"));

exports.VisibilityTracker = react_1.default.memo(function (_a) {
  var children = _a.children,
      minTopValue = _a.minTopValue,
      scrollDelay = _a.scrollDelay,
      intervalDelay = _a.intervalDelay,
      visibilityChangeHandler = _a.visibilityChangeHandler;
  return react_1.default.createElement(react_visibility_sensor_1.default, {
    onChange: visibilityChangeHandler,
    minTopValue: minTopValue,
    scrollDelay: scrollDelay,
    intervalDelay: intervalDelay
  }, children);
});